<script>
import moment from "moment";
import PagenationContainer from "@/components/common/PagenationContainer.vue";
export default {
  components: {
    PagenationContainer
  },
  data() {
    return {
      tableData: [],
      pageCount: 0,
      activePage: 1
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      let params = {
        page: this.activePage - 1
      };
      let data = await this.$http.getTrainLogsList(params);
      console.log("____::", data, data.content, data.content.length);
      if (data && data.content) {
        this.pageCount = data.totalPages;
        let newTableData = [];
        data.content.forEach(item => {
          newTableData.push({
            id: item.id,
            createdAt: moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss"),
            event: item.event,
            operateName: item.operateName
          });
        });
        this.tableData = newTableData;
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.activePage = val;
      this.loadData();
    }
  }
};
</script>
<template>
  <div class="trainLogsIndex">
    <el-table
      :data="tableData"
      class="accountTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="createdAt" align="left" label="创建时间" width="180"></el-table-column>
      <el-table-column prop="event" align="left" label="日志内容"></el-table-column>
      <el-table-column prop="operateName" align="left" label="操作人" width="100"></el-table-column>
    </el-table>
    <PagenationContainer v-if="pageCount > 1">
      <el-pagination
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss" scoped>
@import "@/css/color.scss";

.trainLogsIndex {
  .accountTable {
    margin: 20px auto;
    border: 1px;
    width: 98%;
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    th > .cell {
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/trainLogs/index.vue